import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';

import CustomButton from '../../components/GeneralForm/CustomButton';

const SyncButton = props => {
  const {
    onClick,
    disabled,
    isLoading = false,
    buttonOptions = {},
    addedClass = '',
    allClasses = '',
    id = '',
    toolTip = ''
  } = props;
  return (
    <>
      <CustomButton
        outline
        id={`sync_${id}`}
        className={allClasses ? allClasses : `d-flex align-items-center ${addedClass}`}
        {...buttonOptions}
        onClick={onClick}
        disabled={disabled || isLoading}
      >
        <i className={`fa fa-refresh   ${isLoading ? ' fa-spin ' : ''} `} />
      </CustomButton>
      <UncontrolledTooltip placement="top" target={`sync_${id}`}>
        {toolTip ? toolTip : 'Click to sync data.'}
      </UncontrolledTooltip>
    </>
  );
};
export default SyncButton;
